import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import { ReactComponent as ChevronLeft } from '../../assets/svg/ChevronLeft.svg';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import { notif } from '../utils/util';
import Loading from '../../utils/Loading';
import { forgotPassword } from '../../server/server';

type Inputs = {
	email: string;
};

interface SignIn {
	setSelectedMode: any;
}

function ForgotPassword({ setSelectedMode }: SignIn) {
	const navigate = useNavigate();
	const { setUser } = useUser();
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);

	const {
		register,
		handleSubmit,
		watch,
		getValues,
		setValue,
		reset,
		formState: { errors },
	} = useForm<Inputs>({
		defaultValues: {
			email: '',
		},
	});

	const onSubmit: SubmitHandler<Inputs> = async () => {
		resetPassword();
	};
	const resetPassword = async () => {
		setLoading(true);
		const response = await forgotPassword({
			email: getValues('email'),
		});
		if (response.status === 201) {
			const data = response.data;
			setErrorMessage('');
			console.log('registration success', data);
			notif('Pogledajte u email sanduce i otvorite link za kreiranje nove lozinke (pogledajte spam ili junk folder ukoliko nije u inboxu).', 'info', 15000);
			setSelectedMode('login');
		} else {
			console.log('forgot password error', response?.data);
			notif('Nije prosao zahtev za oporavak');
			setErrorMessage(response?.data?.message);
		}
		setLoading(false);
	};

	return (
		<div className='w-full bg-white flex flex-col items-center'>
			<div className='flex flex-col max-w-[430px] w-full px-3 m-auto '>
				<p className='text-[32px] leading-[44px] text-black700  font-bold  '>Oporavak lozinke</p>
				<p className='text-[16px] leading-5 text-black700 font-medium mt-[12px] mb-[32px] '>
					Poštovani molim Vas unesite email adresu koji ste koristili za registraciju u sistemu kako bi ste oporavili zaboravljenu lozinku.
				</p>
				<form className='flex flex-col items-center w-full ' onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
					<div className='flex flex-col w-full'>
						<label className='text-[16px] leading-5 text-black700 font-bold  '>Email adresa</label>
						<div className=' border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center '>
							<input
								className='text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 '
								placeholder='Email adresa'
								{...register('email', {
									required: true,
									pattern: {
										value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
										message: 'invalid email address',
									},
								})}
							/>
						</div>
						<span className='text-redError text-[12px] leading-5 h-5 '>
							{errors.email?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
							{errors.email?.type === 'pattern' ? 'Email adresa nije ispravno popunjena!' : ''}
						</span>
					</div>
					<p className='text-redError text-[12px] leading-5 h-5 '>{!!errorMessage ? errorMessage : ''}</p>
					<button
						type='submit'
						className='w-full h-[50px] flex items-center justify-center rounded-[4px] bg-orange300 hover:bg-orange400 text-[18px] text-black700 font-bold cursor-pointer mt-1'
						disabled={loading}
					>
						{loading ? <Loading size={25} /> : 'Pošalji link za oporavak lozinke'}
					</button>
					<button
						type='submit'
						className={`mt-8 flex-1 h-[48px] flex items-center justify-center gap-3 rounded-[4px]   text-[18px] text-black700 font-bold cursor-pointer`}
						disabled={loading}
						onClick={() => setSelectedMode('login')}
					>
						<ChevronLeft />
						<p>Nazad</p>
					</button>
				</form>
			</div>
		</div>
	);
}

export default ForgotPassword;
